var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 1)?_c('home-pay'):_c('home-doctor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }